export default ({ day, color }) => `<div class="daily-circles">
<svg height="12" width="12" class="risk-svg">
  <circle cx="6" cy="6" r="6" class=${color} />
</svg>
<span>${day}</span>
</div>`;
